//dependencies
import dropdown from "angular-ui-bootstrap/src/dropdown";
import collapse from "angular-ui-bootstrap/src/collapse";
import tabs from "angular-ui-bootstrap/src/tabs";

//services
// replace: \.(component|directive)\("(\w+)",\s*(\w+)\) with: $2,

//components
import changeNoticeList from "emun.order/change-notices/change-notice-list";

//directives
import changeNoticeListGrid from "emun.order/change-notices/change-notice-list-grid";
import changeNoticeListCards from "emun.order/change-notices/change-notice-list-cards";
// import states from "emun.order/change-notices/change-notice.states";

export const dependencies = [dropdown, collapse, tabs];

export const modules = {
  // modals,
};

//const deps = ["emun.auth", "webutils", "webforms", "webmodals", "ui.router"];

export const services = {};

export const components = {
  changeNoticeList
};

export const directives = {
  changeNoticeListGrid,
  changeNoticeListCards
};

export default {
  modules,
  services,
  dependencies,
  components,
  directives
  // states
};
